var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "terms-gate",
      staticStyle: {
        display: "flex",
        "min-height": "100vh",
        width: "100%",
        "flex-direction": "column",
        "align-items": "center",
        "justify-content": "center",
        gap: "24px",
        padding: "24px",
        "text-align": "center"
      }
    },
    [
      _c("div", {
        staticClass: "terms-gate__logo",
        staticStyle: {
          width: "220px",
          height: "48px",
          "background-image": "var(--brand-logo)",
          "background-size": "contain",
          "background-position": "center",
          "background-repeat": "no-repeat"
        },
        attrs: { role: "img", "aria-label": "Ringba" }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            "max-width": "448px",
            margin: "0",
            "font-size": "14px",
            "line-height": "1.5"
          }
        },
        [
          _vm._v("\n    By clicking "),
          _c("strong", [_vm._v("I Accept")]),
          _vm._v(", you confirm that you have read and understood the\n    "),
          _c(
            "a",
            {
              staticStyle: { color: "#04CDFF", "text-decoration": "underline" },
              attrs: {
                href: _vm.termsUrl,
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [_vm._v("Ringba Terms & Conditions")]
          ),
          _vm._v(
            ",\n    and you agree to be legally bound by them. Acceptance is required to continue using the Ringba platform.\n    If you do not agree, you must discontinue use.\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            gap: "8px",
            "font-size": "14px"
          }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.agreed,
                expression: "agreed"
              }
            ],
            staticStyle: {
              width: "16px",
              height: "16px",
              margin: "0",
              cursor: "pointer",
              "accent-color": "var(--component-btn--primary-bg-border-color)"
            },
            attrs: {
              id: "terms-agree-checkbox",
              type: "checkbox",
              "data-testid": "terms-agree-checkbox"
            },
            domProps: {
              checked: Array.isArray(_vm.agreed)
                ? _vm._i(_vm.agreed, null) > -1
                : _vm.agreed
            },
            on: {
              change: function($event) {
                var $$a = _vm.agreed,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.agreed = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.agreed = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.agreed = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _c("span", [
            _c(
              "label",
              {
                staticStyle: {
                  margin: "0",
                  "font-weight": "normal",
                  cursor: "pointer"
                },
                attrs: { for: "terms-agree-checkbox" }
              },
              [_vm._v("I have read and agree to the ")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticStyle: {
                  color: "#04CDFF",
                  "text-decoration": "underline"
                },
                attrs: {
                  href: _vm.termsUrl,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v("Ringba Terms & Conditions.")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          staticStyle: {
            "text-transform": "none",
            "letter-spacing": "normal",
            "font-size": "14px",
            "min-width": "120px"
          },
          attrs: {
            type: "button",
            "data-testid": "terms-accept-button",
            disabled: _vm.isSubmitting || !_vm.agreed
          },
          on: { click: _vm.accept }
        },
        [_vm._v("\n    I Accept\n  ")]
      ),
      _vm._v(" "),
      _vm.errorMessage
        ? _c(
            "p",
            {
              staticStyle: {
                "max-width": "448px",
                margin: "0",
                color: "#E52222",
                "font-size": "14px"
              },
              attrs: { "data-testid": "terms-error-message" }
            },
            [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }